package org.hs_soft.runmynesto.domain.usecase.options.cash_register_config

import org.hs_soft.runmynesto.domain.model.home.options.cash_register_config.hardware.adyen_store.AdyenStoreModel
import org.hs_soft.runmynesto.domain.repository.network_datasource.options.cash_register_config.AydenStoresRepository


class AydenStoresUseCase(
    private val repository: AydenStoresRepository
) {
    suspend operator fun invoke(): AdyenStoreModel {
        return repository.getAydenStores( )
    }
}